let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jo1k7")).then(() => parcelRequire('6P642'));